var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { callAPI } from "../../lib/common";
export class CheckoutService {
    create() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield callAPI("/api/webshop/checkout", "POST");
                return data;
            }
            catch (error) {
                throw new Error(`Failed to create checkout: ${error.message}`);
            }
        });
    }
    getPaymentOptionsByDeliveryOptionUuid(checkoutUuid, deliveryOptionUuid) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield callAPI(`/api/webshop/checkout/${checkoutUuid}/delivery-options/${deliveryOptionUuid}/payment-options`, "GET");
                return data;
            }
            catch (error) {
                throw new Error(`Failed to fetch payment options: ${error.message}`);
            }
        });
    }
    setPaymentOptionUuid(checkoutUuid, deliveryOptionUuid, paymentOptionUuid) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield callAPI(`/api/webshop/checkout/${checkoutUuid}/delivery-options/${deliveryOptionUuid}/payment-options/${paymentOptionUuid}`, "GET");
                return data;
            }
            catch (error) {
                throw new Error(`Failed to set payment option: ${error.message}`);
            }
        });
    }
    useVoucherCode(checkoutUuid, code, deliveryOptionUuid) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield callAPI(`/api/webshop/checkout/${checkoutUuid}/verify-rebate-code`, "POST", { code, deliveryOptionUuid });
                return data;
            }
            catch (error) {
                throw new Error(`Failed to use voucher code: ${error.message}`);
            }
        });
    }
    buyDigitalSets(checkoutUuid, digitalSets, paymentOptionUuid) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield callAPI(`/api/webshop/checkout/${checkoutUuid}/digital-sets`, "POST", { data: digitalSets });
                return data;
            }
            catch (error) {
                throw new Error(`Failed to buy digital sets: ${error.message}`);
            }
        });
    }
    buyCatalogues(checkoutUuid, catalogues, paymentOptionUuid) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield callAPI(`/api/webshop/checkout/${checkoutUuid}/catalogues`, "POST", { catalogues });
                return data;
            }
            catch (error) {
                throw new Error(`Failed to add catalogues to cart: ${error.message}`);
            }
        });
    }
    createTransaction(checkoutUuid, requestData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield callAPI(`/api/webshop/checkout/${checkoutUuid}/transaction`, "POST", requestData);
                return data;
            }
            catch (error) {
                throw new Error(`Failed to create transaction: ${error.message}`);
            }
        });
    }
}
